import React, { useState } from "react"
import { Hidden, Box, Button, makeStyles, ButtonGroup, Menu, MenuItem } from "@material-ui/core"
import { ArrowDropDown } from "@material-ui/icons"
import { Trans } from "@lingui/macro"
import { RowBox, LoadingSpinner } from ".."
import { preventDefault } from "../../utils"

const useStyles = makeStyles((theme) => ({
  container: {
    justifyContent: "flex-end"
  },
  actions: {
    display: "flex",
    flexDirection: ({ stack }) => (stack ? "column-reverse" : "row"),
    gap: theme.spacing(1)
  },
  extraSubmitButton: {
    maxWidth: 40
  }
}))

const CreatorActions = ({
  id,
  onClose,
  onSubmit,
  submitLabel,
  submitLoading,
  submitColor = "primary",
  extraSubmits,
  cancelLabel = <Trans>Cancel</Trans>,
  subject,
  customMobile,
  customDesktop,
  disableSubmit,
  stack = false
}) => {
  const classes = useStyles({ stack })

  const buttonDisabled = disableSubmit || submitLoading

  const [showMenu, setShowMenu] = useState(false)
  const [showMenuEl, setShowMenuEl] = useState(null)

  const handleToggleMenu = ({ currentTarget }) => {
    setShowMenuEl(!showMenu ? currentTarget : null)
    setShowMenu(!showMenu)
  }

  return (
    <>
      {/* Mobile buttons */}
      <Hidden smUp>
        {customMobile}
        {!customMobile && (
          <Box className={classes.actions}>
            {onClose && (
              <Button
                id={`${id}-cancel`}
                variant="contained"
                fullWidth
                aria-label="cancel"
                onClick={(event) => preventDefault(event, () => onClose(event, true))}
                disabled={submitLoading}
                size="large"
              >
                {cancelLabel}
              </Button>
            )}
            {!extraSubmits && onSubmit && (
              <Button
                id={`${id}-submit`}
                variant="contained"
                color={submitColor}
                fullWidth
                onClick={onSubmit}
                disabled={buttonDisabled}
                size="large"
              >
                {!submitLoading && <>{submitLabel || <Trans>Save {subject && String(subject).toLowerCase()}</Trans>}</>}
                {submitLoading && <LoadingSpinner size="24px" delay={false} />}
              </Button>
            )}
            {extraSubmits && extraSubmits.length > 0 && (
              <>
                <ButtonGroup variant="contained" fullWidth color={submitColor}>
                  <Button id={`${id}-submit`} onClick={onSubmit} disabled={disableSubmit || submitLoading}>
                    {!submitLoading && (
                      <>{submitLabel || <Trans>Save {subject && String(subject).toLowerCase()}</Trans>}</>
                    )}
                    {submitLoading && <LoadingSpinner size="24px" delay={false} />}
                  </Button>
                  <Button
                    size="small"
                    className={classes.extraSubmitButton}
                    onClick={handleToggleMenu}
                    disabled={buttonDisabled}
                  >
                    <ArrowDropDown />
                  </Button>
                </ButtonGroup>
                <Menu
                  anchorEl={showMenuEl}
                  keepMounted
                  open={showMenu}
                  onClose={handleToggleMenu}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right"
                  }}
                  transformOrigin={{
                    vertical: "bottom",
                    horizontal: "right"
                  }}
                >
                  {extraSubmits.map((submit, index) => (
                    <MenuItem key={index} onClick={submit.onSubmit}>
                      {submit.label}
                    </MenuItem>
                  ))}
                </Menu>
              </>
            )}
          </Box>
        )}
      </Hidden>

      {/* Desktop buttons */}
      <Hidden xsDown>
        {customDesktop}
        {!customDesktop && (
          <RowBox gap={1} className={classes.container}>
            {onClose && (
              <Button
                id={`${id}-cancel`}
                onClick={(event) => onClose(event, true)}
                variant="text"
                aria-label="cancel"
                disabled={submitLoading}
              >
                {cancelLabel}
              </Button>
            )}
            {!extraSubmits && onSubmit && (
              <Button
                id={`${id}-submit`}
                variant="contained"
                color={submitColor}
                onClick={onSubmit}
                disabled={buttonDisabled}
              >
                {!submitLoading && <>{submitLabel || <>Save {subject && subject.toLowerCase()}</>}</>}
                {submitLoading && <LoadingSpinner size="24px" delay={false} />}
              </Button>
            )}
            {extraSubmits && extraSubmits.length > 0 && (
              <>
                <ButtonGroup variant="contained" color={submitColor}>
                  <Button id={`${id}-submit`} onClick={onSubmit} disabled={disableSubmit || submitLoading}>
                    {!submitLoading && <>{submitLabel || <>Save {subject && subject.toLowerCase()}</>}</>}
                    {submitLoading && <LoadingSpinner size="24px" delay={false} />}
                  </Button>
                  <Button size="small" onClick={handleToggleMenu} disabled={disableSubmit || submitLoading}>
                    <ArrowDropDown />
                  </Button>
                </ButtonGroup>
                <Menu
                  anchorEl={showMenuEl}
                  getContentAnchorEl={null}
                  keepMounted
                  open={showMenu}
                  onClose={handleToggleMenu}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right"
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "right"
                  }}
                >
                  {extraSubmits.map((submit, index) => (
                    <MenuItem key={index} onClick={submit.onSubmit}>
                      {submit.label}
                    </MenuItem>
                  ))}
                </Menu>
              </>
            )}
          </RowBox>
        )}
      </Hidden>
    </>
  )
}

export { CreatorActions }
